const backgroundAuthText = 'Keeping You\nConnected.';

export { backgroundAuthText };
